import { Modal } from "react-bootstrap"

const CroppieModal = ({ show, croppedImage, croppieClose, handleHide, modalWidth, from , postWidth, productCroppie }) => {

    const setHeading = () => {
        if (from == "editor-link") {
            return "Crop Link Image"
        }
        else if (from == "banners") {
            return "Crop Profile Banner"
        }
        else {
            return "Crop Image"
        }
    }
    const width =  productCroppie == "productCroppie" ? "productCroppie" : postWidth ? "postWidth" : "productModal";
    return (
        <Modal centered show={show} onHide={handleHide} id={modalWidth ? width : "ppModal"}>


            <Modal.Header class="modal-header create-biolink-header py-2 px-3">
                <h5 class="modal-title">
                    {setHeading()}
                </h5>
                <button type="button" class="close" onClick={croppieClose} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div id="image_demo2" style={modalWidth ? null : { width: "350px", margin: "0 auto", marginTop: "30px" }}></div>
                    </div>
                    <div class="d-flex gap-2 mt-20px align-items-center justify-content-center">
                        <button type="button" onClick={croppieClose} class="fs-12 w-50 mt-0 integration-btns integration-btn-grey">
                            Cancel
                        </button>
                        <button type="button" onClick={croppedImage} class="fs-12 w-50 shadow-none  project-blue-btn">
                            Crop and Upload
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default CroppieModal